enum STORES {
  UI = 'af-stores_ui',
}

enum STORAGE {
  FILTER = 'af-storage_filters',
  HELP_TIPS = 'af-storage_help_tips',
}

export { STORES, STORAGE };
